import { createTypes, createActions } from '@wix/restaurants-redux/dist/actions/ActionCreatorHelper';
import PropTypes from 'proptypes';

const seatingActions = [
    {
        type: 'INIT_SESSION',
        propTypes: {}
    },
    {
        type: 'SET_ACTIVATION_STATUS',
        propTypes: {
            isEnabled: PropTypes.bool.isRequired,
            maxDate: PropTypes.oneOfType([PropTypes.object, PropTypes.string, PropTypes.number])
        }
    },
    {
        type: 'SUBMIT_RESERVATION_FORM',
        propTypes: {}
    },
    {
        type: 'SUBMIT_FULL_RESERVATION_FORM',
        propTypes: { }
    },
    {
        type: 'SUBMIT_FULL_RESERVATION_FORM_START',
        propTypes: { }
    },
    {
        type: 'SUBMIT_FULL_RESERVATION_FORM_END',
        propTypes: { }
    },
    {
        type: 'SHOW_DETAILS_FORM',
        propTypes: {
            preview: PropTypes.bool
        }
    },
    {
        type: 'SHOW_POLICY',
        propTypes: {

        }
    },   {
        type: 'HIDE_POLICY',
        propTypes: {

        }
    }, {
        type: 'SHOW_TERMS',
        propTypes: {

        }
    },   {
        type: 'HIDE_TERMS',
        propTypes: {

        }
    },
    {
        type: 'CLOSE_DETAILS_FORM',
        propTypes: {}
    },
    {
        type: 'FORM_END',
        propTypes: {}
    },
    {
        type: 'RESERVATION_SUCCESS',
        propTypes: {
            preview: PropTypes.bool
        }
    },
    {
        type: 'RESERVATION_ERROR',
        propTypes: {}
    },
    {
        type: 'SHOW_SMS_VALIDATION',
        propTypes: {}
    },
    {
        type: 'SHOW_NOT_ENABLED',
        propTypes: {
            preview: PropTypes.bool
        }
    },
    {
        type: 'GOTO_START',
        propTypes: {}
    },
    {
        type: 'RESERVATION_RESPONSE',
        propTypes: {
            reserveResponse: PropTypes.object,
            errorResponse: PropTypes.object
        }
    },
    {
        type: 'SMS_VALIDATION',
        propTypes: {
            code: PropTypes.string
        }
    },
    {
        type: 'SET_STEPS',
        propTypes: {
            step: PropTypes.number,
            stepOptions: PropTypes.object
        }
    },
    {
        type: 'GO_BACK',
        propTypes: {}
    },
    {
        type: 'PREVIEW_RESERVATIONS',
        propTypes: {}
    },
    {
        type: 'UPGRADE',
        propTypes: {}
    },
    {
        type: 'OPEN_DASHBOARD',
        propTypes: {}
    },
    {
        type: 'DROPDOWN_READY',
        propTypes: {
            type: PropTypes.string.isRequired
        }
    },
    {
        type: 'DROPDOWN_UPDATING',
        propTypes: {
            type: PropTypes.string.isRequired
        }
    },
    {
        type: 'APP_LOADED',
        propTypes: {}
    },
    {
        type: 'SCROLL_TO_TOP',
        propTypes: {}
    },
    {
        type: 'SET_INTERACTIONS',
        propTypes: {
            interactions: PropTypes.object
        }
    }
];

const ACTION_PREFIX = 'SEATING_SESSION_';
export const types   = createTypes(seatingActions, ACTION_PREFIX);
export const actions = createActions(seatingActions, ACTION_PREFIX);
